import { getConsultationsByUserId } from 'src/api/consultation';
import { ConsultationType } from 'src/pages/types';
import { load } from 'src/redux/consultations/reducer';
import { AppDispatch } from '..';

export const loadConsultationsThunk =
  (user_id?: string) =>
  async (dispatch: AppDispatch): Promise<ConsultationType[] | null> => {
    try {
      const consultations: Array<ConsultationType> = await getConsultationsByUserId();

      if (Array.isArray(consultations)) {
        dispatch(load(consultations));
        return consultations;
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
